import { LoaderTypeEnum } from 'libs/shared/utils/loader/src/lib/+state/loader.models'

export enum UserDialogFunctionEnum {
  Update = 'update',
  Create = 'create',
}

export const usersEntityName = 'Users'

export const USERS_LOADER = {
  // todo remove below from ticketing section
  createUser: {
    id: 'createUser',
    type: LoaderTypeEnum.Button,
  },
  deleteUser: {
    id: 'deleteUser',
    message: 'LOADER.DELETING_USER',
  },
  importUsers: {
    id: 'importUsers',
    message: 'LOADER.IMPORTING_USERS',
  },
}

export enum UserIdentityTypeEnum {
  Email = 'email',
  Mobile = 'mobile',
}
